import Cookies from 'js-cookie'


const TokenKey = 'X-ViaWatchMall-Token'

const BuyKey = 'X-ViaWatchMall-Buy'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUserId() {
  return Cookies.get('userId')
}

export function setUserId(userId) {
  return Cookies.set('userId', userId)
}

export function removeUserId() {
  return Cookies.remove('userId')
}

export function getBuy() {
  return localStorage.getItem(BuyKey)
}
export function setBuy(value) {
  return localStorage.setItem(BuyKey, value)
}
export function removeBuy() {
  return localStorage.removeItem(BuyKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js